// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var PaymentEscalationProcessEditController = function ($rootScope, $scope, $routeParams, PaymentEscalationProcess, DocumentTemplate, gettext, Features, EmailNotificationsTemplate, gettextCatalog) {
    if ($routeParams.paymentEscalationProcessId)
        $scope.process = PaymentEscalationProcess.get({ paymentEscalationProcessId: $routeParams.paymentEscalationProcessId });
    else
        $scope.process = new PaymentEscalationProcess();

    $scope.noneTemplateId = "000000000000000000000000";

    $scope.informationLink = "https://help.frisbii.com/frisbii-transform/docs/how-can-i-configure-the-payment-escalation";
    
    $scope.newStep = { Action: "TriggerWebhook", TriggerDays: 1 };
    $scope.templates = DocumentTemplate.query({ documentType: 'Dunning' }, function () { });

    EmailNotificationsTemplate.query({ category: "OrderSucceeded" }, function (data) {
        $scope.emailNotifications = data;
    });

    $scope.endContractOptionType = Object.freeze({
        "Immediately": "Immediately",
        "AfterPeriod": "AfterPeriod"
    });

    $scope.pauseContractOptionType = Object.freeze({
        "Immediately": "Immediately",
        "AfterTheCurrentBillingPeriod": "AfterTheCurrentBillingPeriod"
    });

    $scope.endContractOptions = Object.freeze([
        {
            "key": $scope.endContractOptionType.Immediately,
            "value": $scope.endContractOptionType.Immediately,
            "text": gettext("Immediately")
        },
        {
            "key": $scope.endContractOptionType.AfterPeriod,
            "value": $scope.endContractOptionType.AfterPeriod,
            "text": gettext("After current period")
        }]);

    $scope.pauseContractOptions = Object.freeze([
        {
            "key": $scope.pauseContractOptionType.Immediately,
            "value": $scope.pauseContractOptionType.Immediately,
            "text": gettext("Immediately")
        },
        {
            "key": $scope.pauseContractOptionType.AfterTheCurrentBillingPeriod,
            "value": $scope.pauseContractOptionType.AfterTheCurrentBillingPeriod,
            "text": gettext("After the current billing period")
        }]);

    $scope.customerLockOptionType = Object.freeze({
        "OnlyForDirectDebit": "OnlyForDirectDebit",
        "ForAllPaymentMethods": "ForAllPaymentMethods"
    });

    $scope.customerLockOptions = Object.freeze([
        {
            "key": $scope.customerLockOptionType.OnlyForDirectDebit,
            "value": $scope.customerLockOptionType.OnlyForDirectDebit,
            "text": gettext("Only for direct debit")
        },
        {
            "key": $scope.customerLockOptionType.ForAllPaymentMethods,
            "value": $scope.customerLockOptionType.ForAllPaymentMethods,
            "text": gettext("For all payment methods")
        }
    ]);

    $scope.EscalationActionType = Object.freeze({
        "SendEmail": "SendEmail",
        "TriggerWebhook": "TriggerWebhook",
        "CreateDunning": "CreateDunning",
        "PauseContract": "PauseContract",
        "EndContract": "EndContract",
        "CloseAccount": "CloseAccount",
        "LockCustomer": "LockCustomer",
        "TransferToAtrigaDebitOnly": "TransferToAtrigaDebitOnly",
        "SwitchToFallback": "SwitchToFallback"
    });

    $scope.addStep = function () {
        // TODO: Validate $scope.newStep
        if (!$scope.process.Steps)
            $scope.process.Steps = [];

        // Set default value for entities without Rtl flag. Lock option dropdown is Rtl specific.
        if ($scope.newStep.Action === $scope.EscalationActionType.LockCustomer)
            if (!$scope.newStep.CustomerLockOption)
                $scope.newStep.CustomerLockOption = $scope.customerLockOptionType.ForAllPaymentMethods;

        $scope.process.Steps.push($scope.newStep);
        $scope.process.Steps.sort(function (a, b) { return a.TriggerDays - b.TriggerDays; });
        $scope.newStep = { Action: $scope.EscalationActionType.TriggerWebhook, TriggerDays: 1 };
    };

    $scope.removeStep = function (step) {
        $scope.process.Steps.destroy(step);
    };

    $scope.getDocumentTemplateName = function (id) {
        for (var i = 0; i < $scope.templates.length; i++)
            if ($scope.templates[i].Id === id)
                return $scope.templates[i].Name;
        return null;
    };

    function findInArrayByKey(array, key) {
        if (key) {
            for (var i = 0; i < array.length; i++) {
                if (array[i].key === key) {
                    return array[i].text;
                }
            }
        }
    };

    $scope.getEndContractType = function (val) {
        return findInArrayByKey($scope.endContractOptions, val);
    };

    $scope.getCustomerLockType = function (val) {
        return findInArrayByKey($scope.customerLockOptions, val);
    };

    $scope.getEmailNotificationTemplateInternalName = function (id) {
        if (id === $scope.noneTemplateId)
            return gettextCatalog.getString(gettext("No Email Notification"));
        if (!id)
            return null;

        return $scope.emailNotifications.find(function (template) { return template.Id === id; }).InternalName;
    };

    $scope.getPauseContractType = function (val) {
        return findInArrayByKey($scope.pauseContractOptions, val);
    };

    $scope.features = Features.features;

    $scope.isAvailableByFeature = function (featureName) {
        var value = $scope.features[featureName];
        return !!value;
    };

    function finish() {
        $scope.notifySuccess();
        $scope.process = PaymentEscalationProcess.get({ paymentEscalationProcessId: $routeParams.paymentEscalationProcessId });
    }

    $scope.save = function () {
        if ($routeParams.paymentEscalationProcessId)
            $scope.process.$update({ paymentEscalationProcessId: $routeParams.paymentEscalationProcessId }, finish);
        else
            $scope.process.$save({}, finish);
    };
};

PaymentEscalationProcessEditController.$inject = ['$rootScope', '$scope', '$routeParams', 'PaymentEscalationProcess', 'DocumentTemplate', 'gettext', 'Features', 'EmailNotificationsTemplate', 'gettextCatalog'];
